
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { MyErrorStateMatcher } from '../../../shared/material.module';
import { DialogData, GlobalsService } from '../../../shared/shared';
import { MoneyRendererComponent } from '../../../shared/grid/renderer/money-renderer.component';
import { GridOptions } from 'ag-grid-community';

@Component({
    selector: 'zahlung-list',
    templateUrl: 'zahlung-list.component.html',
    styleUrls: ['zahlung-list.component.css']
})
export class ZahlungListComponent implements OnInit {
    public matcher = new MyErrorStateMatcher();
    public gridOptions: GridOptions;
    public rowData: any[];
    private columnDefinitions: any[];

    constructor(public dialogRef: MatDialogRef<ZahlungListComponent>, private globalService: GlobalsService, @Inject(MAT_DIALOG_DATA) public dialog: DialogData) {
        this.createColumnDefinitions();
        this.initGrid();
        this.rowData = dialog.Params;
    }

    ngOnInit() {

    }

    initGrid() {
        this.gridOptions = Object.assign(this.globalService.GridOptions, {
            columnDefs: this.columnDefinitions,
            onGridSizeChanged: function (params) {
                params.api.sizeColumnsToFit();
            },
            onViewportChanged: function (params) {
                params.api.sizeColumnsToFit();
            },
        });
    }

    createColumnDefinitions() {
        this.columnDefinitions = [
            {
                headerName: "Id",
                field: "id",
                width: 1,
                hide: true,
                suppressMenu: true
            },
            {
                headerName: "Betrag",
                field: "Betrag",
                width: 200,
                headerClass: "header-right",
                cellRendererFramework: <{ new(): MoneyRendererComponent }>MoneyRendererComponent,
                suppressMenu: true,
                sortable: true,
                resizable: true
            },
            {
                headerName: "Betrag erhalten",
                field: "BetragErhalten",
                width: 200,
                headerClass: "header-right",
                cellRendererFramework: <{ new(): MoneyRendererComponent }>MoneyRendererComponent,
                suppressMenu: true,
                resizable: true,
                sortable: true,
            },
            {
                headerName: "Betrag Offen",
                field: "Betragoffen",
                width: 200,
                headerClass: "header-right",
                cellRendererFramework: <{ new(): MoneyRendererComponent }>MoneyRendererComponent,
                suppressMenu: true,
                resizable: true,
                sortable: true,
            },
        ];
    }

    onCreate(event) {
        if (event === true)
            this.dialogRef.close(true);
    }

    onClose() {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/_vertrag/vertrag-list/zahlung-list/zahlung-list.component.ts